import { render } from "./search-tag.html?vue&type=template&id=259d282f"
import script from "./search-tag-center.vue?vue&type=script&lang=js"
export * from "./search-tag-center.vue?vue&type=script&lang=js"

import "./search-tag-center.vue?vue&type=style&index=0&id=259d282f&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-search-bar/template4/search-tag-center.vue'],['render',render],['__file',"search-tag-center.vue"]])

export default __exports__